import { render } from "./NotificationsLists.vue?vue&type=template&id=0eb58ed8"
import script from "./NotificationsLists.vue?vue&type=script&lang=js"
export * from "./NotificationsLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__